import React from 'react'
import styled from 'styled-components';
import Intl from 'src/components/Intl';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

function Footer() {
  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root id="footer">
            <LeftCol>
              <img src={require('src/assets/images/map.png')} alt="map" />
              <ContactInfos>
                <h3>{t.footer.title}</h3>

                <a
                  href="https://www.google.com/maps/place/4567+Lougheed+Hwy.,+Burnaby,+BC+V5C+3Z6/@49.2681552,-123.0027759,17z/data=!3m1!4b1!4m5!3m4!1s0x5486773174bd0d1b:0xdedd9c167ae1f19d!8m2!3d49.2681552!4d-123.0005819"
                  target="_blank"
                  rel="noopener noreferrer"
                >{t.footer.address}
                </a><br />
                <a
                  href="tel:604-563-8386"
                  rel="noopener noreferrer"
                >{t.footer.phone}
                </a><br />
                <a
                  href="mailto:info@theamazingbrentwood.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.footer.email}
                </a>
                <SubNav>
                  <a
                    href="https://theamazingbrentwood.com/rental/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t.footer.rental}
                  </a>
                  <a
                    href="https://theamazingbrentwood.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t.footer.shoppingCentre}
                  </a>
                  <a href="https://theamazingbrentwood.com/privacy-policy/" target="_blank" rel="noopener noreferrer">{t.footer.privacyPolicy}</a>
                </SubNav>
              </ContactInfos>
            </LeftCol>

            <RightCol>
              <img src={require('src/assets/images/shape.svg')} alt="shape" />
              <SocialMedias>
                <a href="https://www.facebook.com/the.amazing.brentwood.bby/" target="_blank" rel="noopener noreferrer">
                  <img src={require('src/assets/images/fb.svg')} alt="fb" />
                </a>
                <a href="https://twitter.com/inside_tab" target="_blank" rel="noopener noreferrer">
                  <img src={require('src/assets/images/twitter.svg')} alt="twitter" />
                </a>
                <a href="https://www.instagram.com/the.amazing.brentwood/" target="_blank" rel="noopener noreferrer">
                  <img src={require('src/assets/images/ig.svg')} alt="ig" />
                </a>
                <span>{t.footer.at}</span>
              </SocialMedias>
            </RightCol>
          </Root>
        );
      }}
    </Intl>
  );
};

const Root = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #000000;
  
  ${vw('padding-top', 20, 28, 0)}
  ${vw('padding-left', 25, 60, 0)}
  ${vw('padding-right', 25, 98)}
  ${vw('padding-bottom', 29, 36, 0)}

  @media ${media.tablet} {
    flex-direction: column;
  }

  @media ${media.desktop} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const LeftCol = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.tablet} {
    flex-direction: row;
  }

  img {
    ${vw('width', 270, 182, 240)}
    ${vw('height', 250, 168, 222)}
  }
`;

// const Info = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: space-between;

//   ${vw('margin-left', 49)}
//   ${vw('margin-right', 100)}
// `;

const ContactInfos = styled.div`
  ${vw('padding-top', 34, 0, 28)}
  ${vw('padding-bottom', 0, 0, 32)}
  ${vw('padding-left', 0, 33, 49)}

  h3 {
    font-family: 'Gotham Medium';
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #FFFFFF;

    ${vw('font-size', 18)}
    ${vw('line-height', 23)}
    ${vw('margin-bottom', 15, 57, 60)}
  }

  > a {
    font-family: 'Gotham Bold';
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;

    ${vw('font-size', 14, 16)}
    ${vw('line-height', 29)}
  }
`;

const SubNav = styled.nav`
  display: flex;
  flex-direction: column;

  ${vw('padding-top', 15, 0)}

  @media ${media.tablet} {
    flex-direction: row;
  }

  a {
    font-family: 'Gotham Medium';
    font-style: normal;
    font-weight: 500;
    text-transform: capitalize;
    color: #FFFFFF;

    ${vw('font-size', 14, 12, 15)}
    ${vw('line-height', 19, 29)}

    

    &:not(:first-of-type) {
      

      ${vw('margin-left', 0, 8, 13)}
      ${vw('padding-left', 0, 8, 13)}

      @media ${media.tablet} {
        border-left: 1px solid #FFFFFF;
      }
    }
  }
`;

const RightCol = styled.div`
  display: flex;
  flex-direction: column;

  ${vw('padding-top', 33, 38, 28)}
  ${vw('padding-bottom', 0, 0, 32)}

  @media ${media.tablet} {
    flex-direction: row;
    justify-content: flex-start;
  }

  @media ${media.desktop} {
    flex-direction: column;
    justify-content: space-between;
  }
  
  > img {
    ${vw('width', 119, 149)}
    ${vw('height', 36, 46)}

    @media ${media.tablet} {
      align-self: flex-end;
    }
  }
`;

const SocialMedias = styled.div`
  display: flex;
  align-items: center;

  ${vw('padding-top', 23, 0)}
  ${vw('padding-left', 0, 66, 0)}

  @media ${media.tablet} {
    align-items: flex-end;
  }

  @media ${media.desktop} {
    align-items: center;
  }

  > * {
    &:not(:first-child) {
      ${vw('margin-left', 13)}
    }
  }

  span {
    font-family: 'Gotham Bold';
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.05em;
    color: #464849;

    ${vw('font-size', 12, 15)}
    ${vw('line-height', 29)}
  }
`;

export default Footer

